import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

import { Wrapper, Title, Content } from './styles';

export function CollapseToggle(props) {
	const { children, title } = props;
	const [isOpen, setIsOpen] = useState(false);

	const toggle = () => setIsOpen(!isOpen);
	return (
		<Wrapper>
			<Title onClick={toggle}>
				{`${title} `}
				{isOpen ? <ExpandLess /> : <ExpandMore />}
			</Title>
			<Collapse isOpen={isOpen}>
				<Content>{children}</Content>
			</Collapse>
		</Wrapper>
	);
}
